import React, { useContext } from "react";
import moment from "moment";

import CustomFileUpload from "../../../../components/PPA/CustomFileUpload/CustomFileUpload";
import { DatePicker } from "../../../../components/General/DataEntry/DatePicker/DatePicker";
import UserContext from "../../../../context/UserContext";
import PPAContext from "../../../../contexts/PPA/PPAContext";
import {
  CountryLocationList,
  PPAVolumeStructureList,
  yesOrNoList,
  ValuationFreequencyOptions,
  PPAPricingOptions,
  UnbundlingApproachList,
  basisOfCalibrationList,
  GenerationTypeOptions,
  valuationPerspectiveList,
  discountingApproachList,
  discountingConventionList,
  valuationClientTypeList,
} from "../../../../utils/PPA/PPAMasterList";
import "../Style/PPAStyles.css";

function ExistingPPA() {
  const {
    formData,
    SetFormData,
    errors,
    disableNext,
    SetActiveTabId,
    DownloadFile,
    forecastedDates,
    setForecastedDates,
  } = useContext(PPAContext);

  const { authUser } = useContext(UserContext);

  const handleChange = ({ target }) => {
    let newState = {};
    if (target.name === "valuationAtInception" && target.value === "yes") {
      newState = {
        ...formData,
        [target.name]: target.value,
        calibrationAdjustment: null,
        contractStartDate: formData?.valuationDate,
      };
    } else if (target.name === "unbundlingApproach") {
      newState = {
        ...formData,
        [target.name]: target.value,
        unbundlingFactor: undefined,
      };
    } else if (
      target.name === "valuationDate" &&
      formData?.valuationAtInception === "yes"
    ) {
      newState = {
        ...formData,
        [target.name]: target.value,
        contractStartDate: target.value,
      };
    } else if (
      target.name === "modelStartDate" ||
      target.name === "contractEndDate" ||
      target.name === "ppaLocation" ||
      target.name === "useBenchmarkData"
    ) {
      setForecastedDates([]);
      newState = {
        ...formData,
        [target.name]: target.value,
        forecastedDate: "",
      };

      if (target.name === "useBenchmarkData" && target.value === "no") {
        newState = {
          ...newState,
          iscustomised: "Yes",
          blackMarketPrice: "yes",
          greenMarketPrice: "yes",
          uploadMLFCurve: "yes",
          uploadDLFCurve: "yes",
          uploadCurtailmentFactor: "yes",
          inflation: "yes",
          riskFreeRate: "yes",
          assetCreditRiskAdjustment: "yes",
          liabilityCreditRiskAdjustment: "yes",
        };
      }
    } else {
      newState = { ...formData, [target.name]: target.value };
    }
    SetFormData(newState);
  };

  const startEvaluation = () => {
    SetFormData({
      ...formData,
      iscustomised: formData.iscustomised ? formData.iscustomised : "No",
    });
    SetActiveTabId("3");
  };

  const navigateBack = () => {
    SetActiveTabId("1");
  };

  const handleCalValue = (value, category) => {
    handleChange({ target: { name: category, value } });
  };

  const downloadTemplate = (e, fileName) => {
    e.preventDefault();
    const userID = authUser.userName;

    let startDate = formData?.modelStartDate;
    let yearEndDate = formData?.yearEndDate;

    if (
      [
        "volumeCurveAtInception",
        "blackMarketPriceCurveAtInception",
        "greenMarketPriceCurveAtInception",
        "mlfCurveAtInception",
        "dlfCurveAtInception",
        "curtailmentFactorAtInception",
      ].includes(fileName)
    ) {
      startDate = formData?.contractStartDate;

      const modelStartDate = moment(formData?.modelStartDate, "YYYY-MM-DD");
      const contractStartDate = moment(
        formData?.contractStartDate,
        "YYYY-MM-DD",
      );

      if (
        formData?.valuationFreequency === "yearly" &&
        !modelStartDate.isSame(contractStartDate)
      ) {
        const yearEnd = moment(formData?.yearEndDate, "YYYY-MM-DD");
        if (modelStartDate.year() === yearEnd.year()) {
          yearEndDate = yearEnd.format(`${contractStartDate.year()}-MM-DD`);
        } else {
          yearEndDate = yearEnd.format(`${contractStartDate.year() + 1}-MM-DD`);
        }
      }
    }
    DownloadFile(
      fileName,
      userID,
      startDate,
      formData?.contractEndDate,
      formData?.valuationFreequency,
      formData?.valuationAtInception,
      formData?.valuationClientType,
      yearEndDate,
    );
  };

  return (
    <div className="add-evaluation_wrapper">
      <div className="add-evaluation-form-container col-md-12">
        <form className="add-evaluation-form col-md-12" onSubmit={() => {}}>
          <div className="col-md-3">
            <label className="avf-label" htmlFor="ppa-location">
              Asset Location *
            </label>

            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="ppa-location"
                name="ppaLocation"
                value={formData?.ppaLocation}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value </option>
                {CountryLocationList.map((country) => (
                  <option value={country} key={country}>
                    {country}
                  </option>
                ))}
              </select>
              <span className="cppa-custom-tooltip">
                Location of the subject energy generation asset. This influences
                the benchmark pricing and generation data selected for the
                valuation
              </span>
            </div>
            {errors.ppaLocation ? (
              <p className="error">Please Select Asset Location</p>
            ) : null}
          </div>

          <div className="col-md-3">
            <label className="avf-label" htmlFor="valuation-client-type">
              Client Type *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="valuation-client-type"
                name="valuationClientType"
                value={formData?.valuationClientType}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {valuationClientTypeList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select the client type
              </span>
            </div>
            {errors.valuationClientType ? (
              <p className="error">Please Select A Value</p>
            ) : null}
          </div>

          {formData?.valuationClientType === "channel_1" && (
            <>
              <div className="col-md-3">
                <label className="avf-label" htmlFor="generator-name">
                  Client Name *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="client-name"
                    name="clientName"
                    value={formData?.clientName}
                    onChange={handleChange}
                    placeholder="Client Name"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">Client Name</span>
                </div>

                {errors.clientName ? (
                  <p className="error">Please Enter Client Name</p>
                ) : null}
              </div>

              <div className="col-md-3">
                <label className="avf-label" htmlFor="project-name">
                  Project Name *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="project-name"
                    name="projectName"
                    value={formData?.projectName}
                    onChange={handleChange}
                    placeholder="Project Name"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">Project Name</span>
                </div>

                {errors.projectName ? (
                  <p className="error">Please Enter Project Name</p>
                ) : null}
              </div>

              <div className="col-md-3">
                <label className="avf-label" htmlFor="company-name">
                  Company Name *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="company-name"
                    name="companyName"
                    value={formData?.companyName}
                    onChange={handleChange}
                    placeholder="Company Name"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">Company Name</span>
                </div>

                {errors.companyName ? (
                  <p className="error">Please Enter Company Name</p>
                ) : null}
              </div>

              <div className="col-md-3">
                <label className="avf-label" htmlFor="entity-name">
                  Entity Name *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="entity-name"
                    name="entityName"
                    value={formData?.entityName}
                    onChange={handleChange}
                    placeholder="Entity Name"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">Entity Name</span>
                </div>

                {errors.entityName ? (
                  <p className="error">Please Enter Entity Name</p>
                ) : null}
              </div>

              <div className="col-md-3">
                <label className="avf-label" htmlFor="counterparty">
                  Counterparty *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="counterparty"
                    name="counterParty"
                    value={formData?.counterParty}
                    onChange={handleChange}
                    placeholder="Counterparty"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">Counterparty</span>
                </div>

                {errors.counterParty ? (
                  <p className="error">Please Enter Counterparty</p>
                ) : null}
              </div>

              <div className="col-md-3">
                <label className="avf-label" htmlFor="reference-details">
                  Reference Details *
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="reference-details"
                    name="referenceDetails"
                    value={formData?.referenceDetails}
                    onChange={handleChange}
                    placeholder="Reference Details"
                    disabled={formData?.readOnly}
                    required
                  />
                  <span className="cppa-custom-tooltip">Reference Details</span>
                </div>

                {errors.referenceDetails ? (
                  <p className="error">Please Enter Reference Details</p>
                ) : null}
              </div>
            </>
          )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="valuation-perspective">
              Performing Valuation As A *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="valuation-perspective"
                name="valuationPerspective"
                value={formData?.valuationPerspective}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {valuationPerspectiveList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select whether you are valuing the PPA based on the perspective
                of the buyer or seller of the energy.
              </span>
            </div>
            {errors.valuationPerspective ? (
              <p className="error">Please Select A Value</p>
            ) : null}
          </div>

          <DatePicker
            error={errors?.valuationDate ? "Please Select Valuation Date" : ""}
            formClass={"col-md-3"}
            label="Valuation Date * "
            CalValue={formData?.valuationDate}
            setCalValue={handleCalValue}
            id={"valuation-date"}
            placeholder={"Select Date (Required)"}
            category={"valuationDate"}
            helperText="Valuation Date"
            dateFormat="YYYY-MM-DD"
            disabled={formData?.readOnly}
          />

          {formData?.valuationDate && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="valuation-at-inception">
                Valuation At Inception *
              </label>
              <div className="input-wrapper">
                <select
                  className="admin__contract__input"
                  id="valuation-at-inception"
                  name="valuationAtInception"
                  value={formData?.valuationAtInception}
                  onChange={handleChange}
                  disabled={formData?.readOnly || formData?.reValuation}
                  required
                >
                  <option value="">Please Select Any Value</option>
                  {yesOrNoList.map((list) => (
                    <option value={list.value} key={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>

                <span className="cppa-custom-tooltip">
                  Select 'Yes' to calculate the calibration factor at inception
                  to be applied to all valuations
                </span>
              </div>
              {errors.valuationAtInception ? (
                <p className="error">Please Select Valuation At Inception</p>
              ) : null}
            </div>
          )}

          {formData?.valuationDate && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="basis-of-calibration">
                Basis Of Calibration (% or $) *
              </label>
              <div className="input-wrapper">
                <select
                  className="admin__contract__input"
                  id="basis-of-calibration"
                  name="basisOfCalibration"
                  value={formData?.basisOfCalibration}
                  onChange={handleChange}
                  disabled={formData?.readOnly || formData?.reValuation}
                  required
                >
                  <option value="">Please Select Any Value</option>
                  {basisOfCalibrationList.map((list) => (
                    <option value={list.value} key={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>
                <span className="cppa-custom-tooltip">
                  Select whether to apply % calibration adjustment or a $
                  calibration adjustment.
                </span>
              </div>

              {errors.basisOfCalibration ? (
                <p className="error">
                  Please Select A Value For Basis Of Calibration
                </p>
              ) : null}
            </div>
          )}

          {formData?.valuationAtInception === "no" && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="calibration-adjustment">
                Calibration Adjustment{" "}
                {formData?.basisOfCalibration === "usd" ? ` ($/MWh) ` : ` (%) `}{" "}
                *
              </label>
              <div className="input-wrapper">
                <input
                  className="admin__contract__input"
                  type="text"
                  id="calibration-adjustment"
                  name="calibrationAdjustment"
                  value={formData?.calibrationAdjustment}
                  onChange={handleChange}
                  placeholder={
                    formData?.basisOfCalibration === "usd" ? `0.00` : `0.00%`
                  }
                  disabled={formData?.readOnly || formData?.reValuation}
                  required
                />
                <span className="cppa-custom-tooltip">
                  The Calibration Adjustment which will be applied for
                  calculation.
                </span>
              </div>

              {errors.calibrationAdjustment ? (
                <p className="error">Please Provide Calibration Adjustment</p>
              ) : null}
            </div>
          )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="valuation-freequency">
              Forecast Periodicity *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="valuation-freequency"
                name="valuationFreequency"
                value={formData?.valuationFreequency}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {ValuationFreequencyOptions.map((freequency) => (
                  <option value={freequency.value} key={freequency.value}>
                    {freequency.label}
                  </option>
                ))}
              </select>
              <span className="cppa-custom-tooltip">
                The periodicity of the input forecast data
              </span>
            </div>
            {errors.valuationFreequency ? (
              <p className="error">Please select valuation freequency</p>
            ) : null}
          </div>

          <DatePicker
            error={
              errors?.contractStartDate
                ? "Please Select Contract Inception Date"
                : ""
            }
            formClass={"col-md-3"}
            label="Contract Inception Date * "
            CalValue={formData?.contractStartDate}
            setCalValue={handleCalValue}
            id={"contract-start-date"}
            placeholder={"Select Date (Required)"}
            category={"contractStartDate"}
            helperText="The start date of the agreement according to the PPA"
            dateFormat="YYYY-MM-DD"
            disabled={formData?.readOnly || formData?.reValuation}
          />

          <DatePicker
            error={
              errors?.modelStartDate ? "Please Select Model Start Date" : ""
            }
            formClass={"col-md-3"}
            label="Model Start Date * "
            CalValue={formData?.modelStartDate}
            setCalValue={handleCalValue}
            id={"model-start-date"}
            placeholder={"Select Date (Required)"}
            category={"modelStartDate"}
            helperText="The start date of the forecast cash flows"
            dateFormat="YYYY-MM-DD"
            disabled={formData?.readOnly}
          />

          <DatePicker
            error={
              errors?.contractEndDate ? "Please Select Contract End Date" : ""
            }
            formClass={"col-md-3"}
            label="Contract End Date * "
            CalValue={formData?.contractEndDate}
            setCalValue={handleCalValue}
            id={"contract-end-date"}
            placeholder={"Select Date (Required)"}
            category={"contractEndDate"}
            helperText="The end date of the agreement according to the PPA"
            dateFormat="YYYY-MM-DD"
            disabled={formData?.readOnly || formData?.reValuation}
          />
          {formData?.valuationFreequency === "yearly" && (
            <DatePicker
              error={errors?.yearEndDate ? "Please Select Year End Date" : ""}
              formClass={"col-md-3"}
              label="Year End Date * "
              CalValue={formData?.yearEndDate}
              setCalValue={handleCalValue}
              id={"year-end-date"}
              placeholder={"Select Date (Required)"}
              category={"yearEndDate"}
              helperText="Year End Date"
              dateFormat="YYYY-MM-DD"
              disabled={formData?.readOnly}
            />
          )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="ppa_volume_structure">
              PPA Volume Structure *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="ppa-volume-structure"
                name="ppaVolStructure"
                value={formData?.ppaVolStructure}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {PPAVolumeStructureList.map((volume) => (
                  <option value={volume} key={volume}>
                    {volume}
                  </option>
                ))}
              </select>
              <span className="cppa-custom-tooltip">
                Structure of generation volume provided to the buyer according
                to the PPA
              </span>
            </div>
            {errors.ppaVolStructure ? (
              <p className="error">Please Select PPA Volume Structure</p>
            ) : null}
          </div>

          {(formData?.ppaVolStructure === "Baseload" ||
            formData?.ppaVolStructure === "Pay as produced") && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="changing-volume-in-ppa">
                {" "}
                Changing Volumes In PPA *
              </label>
              <div className="input-wrapper">
                <select
                  className="admin__contract__input"
                  id="changing-volume-in-ppa"
                  name="changingVolumeInPPA"
                  value={formData?.changingVolumeInPPA}
                  onChange={handleChange}
                  disabled={formData?.readOnly}
                  required
                >
                  <option value="">Please Select Any Value</option>
                  {yesOrNoList.map((list) => (
                    <option value={list.value} key={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>

                <span className="cppa-custom-tooltip">
                  Select 'Yes' if the volume of generation is variable
                  throughout the term of the PPA. Select ‘No’ if the generation
                  volume is constant throughout the PPA term.
                </span>
              </div>
              {errors.changingVolumeInPPA ? (
                <p className="error">Please Select Changing Volumes In PPA</p>
              ) : null}
            </div>
          )}

          {(formData?.ppaVolStructure === "Baseload" ||
            formData?.ppaVolStructure === "Pay as produced") &&
            formData?.changingVolumeInPPA === "yes" && (
              <div className="col-md-3">
                <label className="avf-label" htmlFor="upload-volumecurve">
                  Upload Generation Volume (GWh) *
                </label>
                <div className="uload_download_block">
                  <CustomFileUpload
                    FormName="volumeCurveFile"
                    UploadButtonText="+ Upload"
                    disabled={formData?.readOnly}
                  ></CustomFileUpload>
                  <span
                    className="download_link collapsed-download-btn"
                    onClick={(e) => downloadTemplate(e, "volumeCurve")}
                  >
                    <img
                      className=""
                      src={"/icons/download.png"}
                      alt="Download"
                    />
                    <span className="cppa-custom-tooltip tooltip-dn-btn">
                      Download Template
                    </span>
                  </span>
                </div>
                {errors.volumeCurveFile ? (
                  <p className="error">Please Upload</p>
                ) : null}
              </div>
            )}

          {formData?.changingVolumeInPPA === "no" &&
            (formData?.ppaVolStructure === "Baseload" ||
              formData?.ppaVolStructure === "Pay as produced") && (
              <>
                <div className="col-md-3">
                  <label className="avf-label" htmlFor="annual-vol-capacity">
                    Annual PPA Volume Capacity (GWh) *
                  </label>
                  <div className="input-wrapper">
                    <input
                      className="admin__contract__input"
                      type="text"
                      id="annual-ppa-vol-capacity"
                      name="annualPPAVolumeCapacity"
                      value={formData?.annualPPAVolumeCapacity}
                      onChange={handleChange}
                      placeholder="Annual PPA Volume Capacity"
                      disabled={formData?.readOnly}
                      required
                    />
                    <span className="cppa-custom-tooltip">
                      Generation capacity of the contracted assets provided to
                      the buyer according to the PPA
                    </span>
                  </div>

                  {errors.annualPPAVolumeCapacity ? (
                    <p className="error">
                      Please Enter Annual PPA Volume Capacity
                    </p>
                  ) : null}
                </div>
              </>
            )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="mlf-included-volume">
              MLF Included In Volume *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="mlf-included-volume"
                name="mlfIncludedInVolume"
                value={formData?.mlfIncludedInVolume}
                onChange={handleChange}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {yesOrNoList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select 'Yes' if MLF is already applied to the provided volume.
              </span>
            </div>
            {errors.mlfIncludedInVolume ? (
              <p className="error">Please Select MLF Included In Volume</p>
            ) : null}
          </div>

          <div className="col-md-3">
            <label className="avf-label" htmlFor="dlf-included-volume">
              DLF Included In Volume *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="dlf-included-volume"
                name="dlfIncludedInVolume"
                value={formData?.dlfIncludedInVolume}
                onChange={handleChange}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {yesOrNoList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select 'Yes' if DLF is already applied to the provided volume.
              </span>
            </div>
            {errors.dlfIncludedInVolume ? (
              <p className="error">Please Select DLF Included In Volume</p>
            ) : null}
          </div>

          <div className="col-md-3">
            <label className="avf-label" htmlFor="curtailment-included-volume">
              Curtailment Included In Volume *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="curtailment-included-volume"
                name="curtailmentIncludedInVolume"
                value={formData?.curtailmentIncludedInVolume}
                onChange={handleChange}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {yesOrNoList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select 'Yes' if Curtailment is already applied to the provided
                volume.
              </span>
            </div>
            {errors.curtailmentIncludedInVolume ? (
              <p className="error">
                Please Select Curtailment Included In Volume
              </p>
            ) : null}
          </div>

          {formData?.changingVolumeInPPA === "yes" && (
            <>
              <div className="col-md-3">
                <label className="avf-label" htmlFor="generation-type">
                  Generation Type *
                </label>
                <div className="input-wrapper">
                  <select
                    className="admin__contract__input"
                    id="generation-type"
                    name="generationType"
                    onChange={handleChange}
                    value={formData?.generationType}
                    disabled={formData?.readOnly}
                    required
                  >
                    <option value="">Please Select Any Value</option>
                    {GenerationTypeOptions.map((pricing) => (
                      <option value={pricing.value} key={pricing.value}>
                        {pricing.label}
                      </option>
                    ))}
                  </select>
                  <span className="cppa-custom-tooltip">Generation Type</span>
                </div>

                {errors.generationType ? (
                  <p className="error">Please Select Generation Type</p>
                ) : null}
              </div>
              {formData?.generationType === "total_asset_generation" && (
                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="counterParty-allocation"
                  >
                    Buyer's Share (%) *
                  </label>
                  <div className="input-wrapper">
                    <input
                      className="admin__contract__input"
                      type="text"
                      id="counterParty-allocation"
                      name="counterPartyAllocation"
                      value={formData?.counterPartyAllocation}
                      onChange={handleChange}
                      placeholder="0.00%"
                      disabled={formData?.readOnly || formData?.reValuation}
                      required
                    />
                    <span className="cppa-custom-tooltip">
                      Allocation of energy to the buyer according to the PPA
                    </span>
                  </div>

                  {errors.counterPartyAllocation ? (
                    <p className="error">Please Enter Buyer's Share</p>
                  ) : null}
                </div>
              )}
            </>
          )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="ppa-pricing">
              PPA Price Structure *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="ppa-pricing"
                name="ppaPricing"
                onChange={handleChange}
                value={formData?.ppaPricing}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {PPAPricingOptions.map((pricing) => (
                  <option value={pricing.value} key={pricing.value}>
                    {pricing.label}
                  </option>
                ))}
              </select>
              <span className="cppa-custom-tooltip">
                Structure of the pricing paid by the buyer over the life of the
                contract according to the PPA
              </span>
            </div>

            {errors.ppaPricing ? (
              <p className="error">Please Select A PPA Price Structure</p>
            ) : null}
          </div>
          {formData?.ppaPricing !== "custom" && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="ppa-price">
                PPA Price - Bundled ($/MWh) *
              </label>
              <div className="input-wrapper">
                <input
                  className="admin__contract__input"
                  type="text"
                  id="ppa-price"
                  name="ppaPrice"
                  value={formData?.ppaPrice}
                  onChange={handleChange}
                  placeholder="0.00"
                  disabled={formData?.readOnly || formData?.reValuation}
                  required
                />
                <span className="cppa-custom-tooltip">
                  Fixed price of bundled energy according to the PPA prior to
                  escalation
                </span>
              </div>

              {errors.ppaPrice ? (
                <p className="error">Please Enter PPA Price</p>
              ) : null}
            </div>
          )}

          {formData?.ppaPricing === "custom" && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="ppa-price-curve">
                PPA Price Curve ($/MWh) *
              </label>
              <div className="uload_download_block">
                <CustomFileUpload
                  FormName="ppaPriceCurve"
                  UploadButtonText="+ Upload"
                  disabled={formData?.readOnly}
                ></CustomFileUpload>
                <span
                  className="download_link collapsed-download-btn"
                  onClick={(e) => downloadTemplate(e, "ppaPriceCurve")}
                >
                  <img
                    className=""
                    src={"/icons/download.png"}
                    alt="Download"
                  />
                  <span className="cppa-custom-tooltip tooltip-dn-btn">
                    Download Template
                  </span>
                </span>
              </div>
              {errors.ppaPriceCurve ? (
                <p className="error">Please Upload</p>
              ) : null}
            </div>
          )}

          {formData?.ppaPricing !== "fix" && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="price1CurveFile">
                PPA Escalation Curve *
              </label>
              <div className="uload_download_block">
                <CustomFileUpload
                  FormName="ppaEscalationCurve"
                  UploadButtonText="+ Upload"
                  disabled={formData?.readOnly}
                ></CustomFileUpload>
                <span
                  className="download_link collapsed-download-btn"
                  onClick={(e) => downloadTemplate(e, "ppaEscalationCurve")}
                >
                  <img
                    className=""
                    src={"/icons/download.png"}
                    alt="Download"
                  />
                  <span className="cppa-custom-tooltip tooltip-dn-btn">
                    Download Template
                  </span>
                </span>
              </div>
              {errors.ppaEscalationCurve ? (
                <p className="error">Please Upload</p>
              ) : null}
            </div>
          )}

          <div className="col-md-3">
            <label className="avf-label" htmlFor="valuation-at-inception">
              Calculate Unbundling Factor *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="calculate-unbundling-factor"
                name="calculateUnbundlingFactor"
                value={formData?.calculateUnbundlingFactor}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {yesOrNoList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select 'Yes' to calculate unbundling factor
              </span>
            </div>
            {errors.calculateUnbundlingFactor ? (
              <p className="error">
                Please Select Whether To Calculate Unbundling Factor Or Not
              </p>
            ) : null}
          </div>

          <div className="col-md-3">
            <label className="avf-label" htmlFor="unbundling-approach">
              Unbundling Approach *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="unbundling-approach"
                name="unbundlingApproach"
                value={formData?.unbundlingApproach}
                onChange={handleChange}
                disabled={formData?.readOnly || formData?.reValuation}
                required
              >
                <option value="">Please Select Any Value</option>
                {UnbundlingApproachList.map((approach) => (
                  <option value={approach.value} key={approach.value}>
                    {approach.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Select approach for unbundling the black and green energy
              </span>
            </div>
            {errors.unbundlingApproach ? (
              <p className="error">Please Select Unbundling Approach</p>
            ) : null}
          </div>

          {formData?.calculateUnbundlingFactor === "yes" &&
            formData?.unbundlingApproach === "flat_unbundling" && (
              <div className="col-md-3">
                <label
                  className="avf-label"
                  htmlFor="unbundling-rounding-multiple"
                >
                  Unbundling Rounding Multiple (%)*
                </label>
                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="unbundling-rounding-multiple"
                    name="unbundlingRoundingMultiple"
                    value={formData?.unbundlingRoundingMultiple}
                    onChange={handleChange}
                    placeholder="0.00"
                    disabled={formData?.readOnly || formData?.reValuation}
                    required
                  />
                  <span className="cppa-custom-tooltip">
                    The rounding multiple which will be applied for flat
                    unbundling approach.
                  </span>
                </div>

                {errors.unbundlingRoundingMultiple ? (
                  <p className="error">
                    Please Enter Unbundling Rounding Multiple
                  </p>
                ) : null}
              </div>
            )}

          {formData?.calculateUnbundlingFactor === "no" &&
            formData?.unbundlingApproach === "flat_unbundling" && (
              <div className="col-md-3">
                <label className="avf-label" htmlFor="unbundling-factor">
                  Unbundling Factor (%)*
                </label>

                <div className="input-wrapper">
                  <input
                    className="admin__contract__input"
                    type="text"
                    id="generator-name"
                    name="unbundlingFactor"
                    value={formData?.unbundlingFactor}
                    onChange={handleChange}
                    placeholder="0.00%"
                    disabled={
                      formData?.readOnly ||
                      (formData?.reValuation &&
                        formData.unbundlingApproach === "flat_unbundling")
                    }
                    required
                  />
                  <span className="cppa-custom-tooltip">Unbundling Factor</span>
                </div>

                {errors.unbundlingFactor ? (
                  <p className="error">
                    Please Enter A Value For Unbundling Factor
                  </p>
                ) : null}
              </div>
            )}

          {formData?.calculateUnbundlingFactor === "no" &&
            formData?.unbundlingApproach &&
            formData?.unbundlingApproach !== "flat_unbundling" && (
              <div className="col-md-3">
                <label className="avf-label" htmlFor="unbundling-factor">
                  Unbundling Factor *
                </label>

                <div className="uload_download_block">
                  <CustomFileUpload
                    FormName="unbundlingFactor"
                    UploadButtonText="+ Upload"
                    disabled={formData?.readOnly}
                  ></CustomFileUpload>
                  <span
                    className="download_link collapsed-download-btn"
                    onClick={(e) => downloadTemplate(e, "unbundlingFactor")}
                  >
                    <img
                      className=""
                      src={"/icons/download.png"}
                      alt="Download"
                    />
                    <span className="cppa-custom-tooltip tooltip-dn-btn">
                      Download Template
                    </span>
                  </span>
                </div>

                {errors.unbundlingFactor ? (
                  <p className="error">Please Upload Unbundling Factor</p>
                ) : null}
              </div>
            )}

          {formData?.valuationAtInception === "no" &&
            formData?.calculateUnbundlingFactor === "yes" && (
              <>
                <div className="col-md-3">
                  <label className="avf-label" htmlFor="volume-curve-inception">
                    Upload Generation Volume At Inception (GWh) *
                  </label>
                  <div className="uload_download_block">
                    <CustomFileUpload
                      FormName="volumeCurveAtInception"
                      UploadButtonText="+ Upload"
                      disabled={formData?.readOnly}
                    ></CustomFileUpload>
                    <span
                      className="download_link collapsed-download-btn"
                      onClick={(e) =>
                        downloadTemplate(e, "volumeCurveAtInception")
                      }
                    >
                      <img
                        className=""
                        src={"/icons/download.png"}
                        alt="Download"
                      />
                      <span className="cppa-custom-tooltip tooltip-dn-btn">
                        Download Template
                      </span>
                    </span>
                  </div>
                  {errors.volumeCurveAtInception ? (
                    <p className="error">Please Upload</p>
                  ) : null}
                </div>

                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="black-market-price-curve-inception"
                  >
                    Black Market Price Curve At Inception*
                  </label>
                  <div className="uload_download_block">
                    <CustomFileUpload
                      FormName="blackMarketPriceCurveAtInception"
                      UploadButtonText="+ Upload"
                      disabled={formData?.readOnly || formData?.reValuation}
                    ></CustomFileUpload>
                    <span
                      className="download_link collapsed-download-btn"
                      onClick={(e) =>
                        downloadTemplate(e, "blackMarketPriceCurveAtInception")
                      }
                    >
                      <img
                        className=""
                        src={"/icons/download.png"}
                        alt="Download"
                      />
                      <span className="cppa-custom-tooltip tooltip-dn-btn">
                        Download Template
                      </span>
                    </span>
                  </div>
                  {errors.blackMarketPriceCurveAtInception ? (
                    <p className="error">Please Upload</p>
                  ) : null}
                </div>

                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="green-market-price-curve-inception"
                  >
                    Green Market Price Curve At Inception*
                  </label>
                  <div className="uload_download_block">
                    <CustomFileUpload
                      FormName="greenMarketPriceCurveAtInception"
                      UploadButtonText="+ Upload"
                      disabled={formData?.readOnly || formData?.reValuation}
                    ></CustomFileUpload>
                    <span
                      className="download_link collapsed-download-btn"
                      onClick={(e) =>
                        downloadTemplate(e, "greenMarketPriceCurveAtInception")
                      }
                    >
                      <img
                        className=""
                        src={"/icons/download.png"}
                        alt="Download"
                      />
                      <span className="cppa-custom-tooltip tooltip-dn-btn">
                        Download Template
                      </span>
                    </span>
                  </div>
                  {errors.greenMarketPriceCurveAtInception ? (
                    <p className="error">Please Upload</p>
                  ) : null}
                </div>

                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="mlf-included-volume-inception"
                  >
                    MLF Included In Volume At Inception *
                  </label>
                  <div className="input-wrapper">
                    <select
                      className="admin__contract__input"
                      id="mlf-included-volume-inception"
                      name="mlfIncludedInVolumeAtInception"
                      value={formData?.mlfIncludedInVolumeAtInception}
                      onChange={handleChange}
                      disabled={formData?.readOnly || formData?.reValuation}
                      required
                    >
                      <option value="">Please Select Any Value</option>
                      {yesOrNoList.map((list) => (
                        <option value={list.value} key={list.value}>
                          {list.label}
                        </option>
                      ))}
                    </select>

                    <span className="cppa-custom-tooltip">
                      Select 'Yes' if MLF is already applied to the provided
                      volume at inception.
                    </span>
                  </div>
                  {errors.mlfIncludedInVolumeAtInception ? (
                    <p className="error">
                      Please Select MLF Included In Volume At Inception
                    </p>
                  ) : null}
                </div>

                {formData?.mlfIncludedInVolumeAtInception === "no" && (
                  <div className="col-md-3">
                    <label className="avf-label" htmlFor="mlf-curve-inception">
                      MLF Curve At Inception*
                    </label>
                    <div className="uload_download_block">
                      <CustomFileUpload
                        FormName="mlfCurveAtInception"
                        UploadButtonText="+ Upload"
                        disabled={formData?.readOnly || formData?.reValuation}
                      ></CustomFileUpload>
                      <span
                        className="download_link collapsed-download-btn"
                        onClick={(e) =>
                          downloadTemplate(e, "mlfCurveAtInception")
                        }
                      >
                        <img
                          className=""
                          src={"/icons/download.png"}
                          alt="Download"
                        />
                        <span className="cppa-custom-tooltip tooltip-dn-btn">
                          Download Template
                        </span>
                      </span>
                    </div>
                    {errors.mlfCurveAtInception ? (
                      <p className="error">Please Upload</p>
                    ) : null}
                  </div>
                )}

                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="dlf-included-volume-inception"
                  >
                    DLF Included In Volume At Inception *
                  </label>
                  <div className="input-wrapper">
                    <select
                      className="admin__contract__input"
                      id="dlf-included-volume-inception"
                      name="dlfIncludedInVolumeAtInception"
                      value={formData?.dlfIncludedInVolumeAtInception}
                      onChange={handleChange}
                      disabled={formData?.readOnly || formData?.reValuation}
                      required
                    >
                      <option value="">Please Select Any Value</option>
                      {yesOrNoList.map((list) => (
                        <option value={list.value} key={list.value}>
                          {list.label}
                        </option>
                      ))}
                    </select>

                    <span className="cppa-custom-tooltip">
                      Select 'Yes' if DLF is already applied to the provided
                      volume at inception.
                    </span>
                  </div>
                  {errors.dlfIncludedInVolumeAtInception ? (
                    <p className="error">
                      Please Select DLF Included In Volume At Inception
                    </p>
                  ) : null}
                </div>

                {formData?.dlfIncludedInVolumeAtInception === "no" && (
                  <div className="col-md-3">
                    <label className="avf-label" htmlFor="dlf-curve-inception">
                      DLF Curve At Inception*
                    </label>
                    <div className="uload_download_block">
                      <CustomFileUpload
                        FormName="dlfCurveAtInception"
                        UploadButtonText="+ Upload"
                        disabled={formData?.readOnly || formData?.reValuation}
                      ></CustomFileUpload>
                      <span
                        className="download_link collapsed-download-btn"
                        onClick={(e) =>
                          downloadTemplate(e, "dlfCurveAtInception")
                        }
                      >
                        <img
                          className=""
                          src={"/icons/download.png"}
                          alt="Download"
                        />
                        <span className="cppa-custom-tooltip tooltip-dn-btn">
                          Download Template
                        </span>
                      </span>
                    </div>
                    {errors.dlfCurveAtInception ? (
                      <p className="error">Please Upload</p>
                    ) : null}
                  </div>
                )}

                <div className="col-md-3">
                  <label
                    className="avf-label"
                    htmlFor="curtailment-included-volume-inception"
                  >
                    Curtailment Included In Volume At Inception *
                  </label>
                  <div className="input-wrapper">
                    <select
                      className="admin__contract__input"
                      id="curtailment-included-volume-inception"
                      name="curtailmentIncludedInVolumeAtInception"
                      value={formData?.curtailmentIncludedInVolumeAtInception}
                      onChange={handleChange}
                      disabled={formData?.readOnly || formData?.reValuation}
                      required
                    >
                      <option value="">Please Select Any Value</option>
                      {yesOrNoList.map((list) => (
                        <option value={list.value} key={list.value}>
                          {list.label}
                        </option>
                      ))}
                    </select>

                    <span className="cppa-custom-tooltip">
                      Select 'Yes' if Curtailment is already applied to the
                      provided volume at inception.
                    </span>
                  </div>
                  {errors.curtailmentIncludedInVolumeAtInception ? (
                    <p className="error">
                      Please Select Curtailment Included In Volume At Inception
                    </p>
                  ) : null}
                </div>

                {formData?.curtailmentIncludedInVolumeAtInception === "no" && (
                  <div className="col-md-3">
                    <label className="avf-label" htmlFor="dlf-curve-inception">
                      Curtailment Factor At Inception*
                    </label>
                    <div className="uload_download_block">
                      <CustomFileUpload
                        FormName="curtailmentFactorAtInception"
                        UploadButtonText="+ Upload"
                        disabled={formData?.readOnly || formData?.reValuation}
                      ></CustomFileUpload>
                      <span
                        className="download_link collapsed-download-btn"
                        onClick={(e) =>
                          downloadTemplate(e, "curtailmentFactorAtInception")
                        }
                      >
                        <img
                          className=""
                          src={"/icons/download.png"}
                          alt="Download"
                        />
                        <span className="cppa-custom-tooltip tooltip-dn-btn">
                          Download Template
                        </span>
                      </span>
                    </div>
                    {errors.curtailmentFactorAtInception ? (
                      <p className="error">Please Upload</p>
                    ) : null}
                  </div>
                )}
              </>
            )}

          <DatePicker
            error={
              errors?.RETSchemeEndDate
                ? "Please Select RET Scheme End Date"
                : ""
            }
            formClass={"col-md-3"}
            label="RET Scheme End Date *"
            CalValue={formData?.RETSchemeEndDate}
            setCalValue={handleCalValue}
            id={"RET-schem-end-date"}
            placeholder={"Select Date (Required)"}
            category={"RETSchemeEndDate"}
            helperText="Assumed end date for the Government’s RET Scheme which will impact forecast green energy"
            dateFormat="YYYY-MM-DD"
            disabled={formData?.readOnly}
          />

          <div className="col-md-3">
            <label className="avf-label" htmlFor="discounting-approach">
              Discounting Approach *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="discounting-approach"
                name="discountingApproach"
                value={formData?.discountingApproach}
                onChange={handleChange}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {discountingApproachList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Discounting approach to calculate the net present value of the
                PPA cash flows. Select 'Period-By-Period Approach' to determine
                which party's credit risk adjustment to apply in each period
                based on whether the corresponding net cash flow is an asset or
                liability, or select 'Net Approach' to apply one party's credit
                risk adjustment only, based on the total net cashflows over the
                forecast period.
              </span>
            </div>
            {errors.discountingApproach ? (
              <p className="error">Please Select A Discounting Approach</p>
            ) : null}
          </div>

          <div className="col-md-3">
            <label className="avf-label" htmlFor="discounting-convention">
              Discounting Convention *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="discounting-convention"
                name="discountingConvention"
                value={formData?.discountingConvention}
                onChange={handleChange}
                disabled={formData?.readOnly}
                required
              >
                <option value="">Please Select Any Value</option>
                {discountingConventionList.map((list) => (
                  <option value={list.value} key={list.value}>
                    {list.label}
                  </option>
                ))}
              </select>

              <span className="cppa-custom-tooltip">
                Preferred discounting convention
              </span>
            </div>
            {errors.discountingConvention ? (
              <p className="error">Please Select A Discounting Convention</p>
            ) : null}
          </div>

          {authUser?.client?.useEYBenchmarkData === "yes" && (
            <div className="col-md-3">
              <label className="avf-label" htmlFor="mlf-included-volume">
                Use EY Benchmark Data *
              </label>
              <div className="input-wrapper">
                <select
                  className="admin__contract__input"
                  id="use-benchmark-data"
                  name="useBenchmarkData"
                  value={formData?.useBenchmarkData}
                  onChange={handleChange}
                  disabled={formData?.readOnly}
                  required
                >
                  <option value="">Please Select Any Value</option>
                  {yesOrNoList.map((list) => (
                    <option value={list.value} key={list.value}>
                      {list.label}
                    </option>
                  ))}
                </select>

                <span className="cppa-custom-tooltip">
                  Select 'Yes' if you want to use EY benchmark data.
                </span>
              </div>
              {errors.useBenchmarkData ? (
                <p className="error">Please Select A Value</p>
              ) : null}
            </div>
          )}

          {formData?.modelStartDate &&
            formData?.contractEndDate &&
            formData?.ppaLocation &&
            authUser?.client?.useEYBenchmarkData === "yes" &&
            formData?.useBenchmarkData === "yes" && (
              <div className="col-md-3">
                <label className="avf-label" htmlFor="forecasted-date">
                  Use Benchmark Data Forecasted On *
                </label>
                <div className="input-wrapper">
                  <select
                    className="admin__contract__input"
                    id="forecasted-date"
                    name="forecastedDate"
                    value={formData?.forecastedDate}
                    onChange={handleChange}
                    disabled={formData?.readOnly}
                    required
                  >
                    <option value="">Please Select Any Value</option>
                    {forecastedDates.map((list) => (
                      <option value={list.value} key={list.value}>
                        {list.label}
                      </option>
                    ))}
                  </select>

                  <span className="cppa-custom-tooltip">
                    Select which benchmark data to use to perform the
                    calculations.
                  </span>
                </div>
                {errors?.forecastedDate ? (
                  <p className="error">Please Select A Value</p>
                ) : null}
              </div>
            )}
          <div className="col-md-3"></div>
        </form>
        <div className="ppa__contract__options ppa-btn-wrapper">
          <button
            className="forward__option btn-secondary"
            onClick={navigateBack}
          >
            Back
          </button>
          <button
            disabled={disableNext}
            className="forward__option btn-primary"
            onClick={startEvaluation}
          >
            Next
          </button>
        </div>
      </div>
      <div className="info-container">
        <span>
          NOTE: Fields marked (*) are mandatory.
          <br />
          All the numeric fields must be in English format.
          <br />
        </span>
      </div>
    </div>
  );
}
export default ExistingPPA;
